export enum atomicsIntent {
  click = 'click',
  cancel = 'cancel',
  submit = 'submit',
}

export type AtomicTaskInteraction<Tasks extends string> =
  `${atomicsIntent}_${Tasks}`;

export type TypeTooWideError =
  "Your string literal type is too wide and is equivalent to 'string'.";

export type StringLiteral<Value extends string> = string extends Value
  ? TypeTooWideError
  : Value;

export type AtomicPolicy<
  ViewName extends string,
  Interaction extends string,
  Task extends string,
  Flow extends string,
> = {
  viewNames: Readonly<StringLiteral<ViewName>[]>;
  interactions: Readonly<StringLiteral<Interaction>[]>;
  tasks: Readonly<StringLiteral<Task>[]>;
  flows: Readonly<StringLiteral<Flow>[]>;
};
